import { useIntl } from 'react-intl';

import { Input } from '@/components/ui/input';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';
import { useBudgetType } from '@/hooks/use-budget-type';

interface BudgetProps {
  label?: string;
}

export function Budget({ label }: BudgetProps) {
  const intl = useIntl();
  const { getEditCampaignBudgetLabel } = useBudgetType();
  const { hookForm, isFetching, campaign, setActiveEditField, isCompleted } =
    useEditCampaignContext();
  const isReadonly = campaign?.is_readonly;

  const {
    register,
    formState: { errors },
    watch,
  } = hookForm;

  const budgetType = watch('budget_type');

  return (
    <Input
      isNumber
      label={label ?? getEditCampaignBudgetLabel(budgetType)}
      {...register('budget', {
        setValueAs: value => (value === '' ? null : Number(value)),
      })}
      placeholderLabel="$"
      placeholder={intl.formatMessage({
        defaultMessage: 'Enter budget',
        description: 'Placeholder for total or rate budget on edit campaign',
      })}
      error={errors.budget?.message}
      isFetching={isFetching}
      onFocus={() => setActiveEditField('budget')}
      onBlur={() => setActiveEditField(null)}
      readOnly={isCompleted || isReadonly}
    />
  );
}
